import client from '../httpClient';
/**
 * @param {{customerIds:number[], userId:number}},
 * @return {Promise<{ data:{
 * customer:{
 * id:number,
 * memberId:number,
 * fullName:string,
 * status:string,
 * statusCode:string,
 * memberStatusCode:string,
 * hashCustomerId:string,
 * }
 * lastReceivedAt:string,
 * user:string,
 * } }>}
 */
const customerPostLineReceptionsApi = (params) => {
  return client.post('/customers/lineReceptions', params, {
    isShowLoading: false,
  });
};

export default customerPostLineReceptionsApi;
